<!-- 设置密码 -->
<template>
  <div class="setPassword">
    <!-- 导航栏 -->
    <van-nav-bar title="设置密码" fixed placeholder z-index="10" @click-left="goBack">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <Account />
    <!-- <SMS v-if="type==0" /> -->
    <div class="password">
      <p>密码</p>
      <div class="pass-tips" v-show="colors&&password==''">
        <img src="@/assets/img/home/tips.png" class="tips" />
        <span>不能为空</span>
      </div>
    </div>
    <div class="input">
      <div class="phone" :style="{borderColor:colors?'red':'#dedede'}">
        <input
          :type="passWordShow?'text':'password'"
          class="password-input"
          @focus="colors=true"
          @blur="colors=false"
          placeholder="请输入密码"
          v-model="password"
        />
        <img :src="passWordShow?imgs[1]:imgs[0]" class="show" @click="(toggle(0))" />
      </div>
    </div>
    <div class="password">
      <p>确认密码</p>
      <div class="pass-tips" v-show="confirmColors&&confirmPassword==''">
        <img src="@/assets/img/home/tips.png" class="tips" />
        <span>不能为空</span>
      </div>
    </div>
    <div class="input">
      <div class="phone" :style="{borderColor:confirmColors?'red':'#dedede'}">
        <input
          :type="passWordConfirm?'text':'password'"
          class="password-input"
          @focus="confirmColors=true"
          @blur="confirmColors=false"
          placeholder="请输入密码"
          v-model="confirmPassword"
        />
        <img :src="passWordConfirm?imgs[1]:imgs[0]" class="show" @click="toggle(1)" />
      </div>
    </div>
    <!-- <passWord /> -->
    <!-- 按钮 -->
    <div class="login-btn" @click="navLogin(0)">
      <van-button type="danger">{{type==0?'立即注册':'确定'}}</van-button>
    </div>
    <div class="log-nav" @click="navLogin(1)">
      <span>已有账号</span>
      <span>去登录</span>
    </div>
    <!-- 弹窗层 -->
    <van-popup v-model="show" round :close-on-click-overlay="false">
      <div class="finish-tips">
        <p>注册成功</p>
        <router-link to="/login/account">
          <button @click="btn">立即登录</button>
        </router-link>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Account from "./AccountNum";
import passWord from "./account";
import SMS from "./SMS";
import { mapState, mapMutations } from "vuex";
import { regTelphone } from "@/until/reg";
import { Toast } from "vant";
import { register } from "@/api/apiData";
export default {
  components: { Account, passWord, SMS },
  data() {
    return {
      type: "", //0 注册设置密码  undefined 重设密码
      show: false,
      passWordShow: false,
      colors: false,
      password: "",
      confirmPassword: "",
      confirmColors: false,
      passWordConfirm: false,
      imgs: [
        require("@/assets/img/home/yinc.png"),
        require("@/assets/img/home/kaiq.png")
      ],
      name: ""
    };
  },
  computed: {
    ...mapState(["telphone", "userParams"])
  },
  methods: {
    ...mapMutations([
      "userRegister",
      "getTelphone",
      "selectAddress",
      "keepAliveRouter"
    ]),
    goBack() {
      this.$router.back();
    },
    toggle(val) {
      if (val == 0) {
        this.passWordShow = !this.passWordShow;
      } else {
        this.passWordConfirm = !this.passWordConfirm;
      }
    },
    //  去登录
    navLogin(val) {
      // 注册设置密码
      const that = this;
      let { telphone, password, confirmPassword, userParams } = that;

      if (val == 0) {
        if (telphone.replace(/[, ]/g, "").length == 0) {
          Toast.fail({
            forbidClick: true,
            message: "请设置登录账号"
          });
          return;
        }
        if (
          password.replace(/[, ]/g, "").length == 0 ||
          confirmPassword.replace(/[, ]/g, "").length == 0
        ) {
          Toast.fail({
            forbidClick: true,
            message: "请设置密码"
          });
          return;
        }
        if (password !== confirmPassword) {
          Toast.fail({
            forbidClick: true,
            message: "密码不一致"
          });
          return;
        }
        // userParams
        let obj = {
          username: telphone,
          password: password,
          avatar:userParams[0].toString(),
          fullname: userParams[1],
          sex: userParams[2],
          nation: userParams[3],
          politics_status: userParams[4],
          id_card: userParams[5],
          district: userParams[6],
          family_address: userParams[7],
          census_register: userParams[8],
          mobile: userParams[9],
          soldier_credential:userParams[10].toString(),
          personnel_type: userParams[11],
          checkin_time: userParams[12],
          checkout_time: userParams[13],
          enlist_address: userParams[14],
          service_length: userParams[15],
          special_care_catid: userParams[16],
          is_martyr_children: userParams[17],
          has_been_tibet: userParams[18],
          is_special_care: userParams[19]
        };
        //(obj);
        register(obj).then(res => {
          if (res.code == 1) {
            this.show = true;
            that.userRegister([]);
            that.getTelphone("");
            that.selectAddress([]);
            that.keepAliveRouter("1");
          } else {
            Toast.fail({
              message: res.msg,
              forbidClick: true
            });
          }
        });
      } else {
        //   首页登录
        this.$router.replace("/login/account");
      }
    },
    btn() {
      this.$router.replace({
        name: "Login"
      });
    }
  },
  created() {
    this.type = this.$route.query.type;
  },
  mounted() {}
};
</script>
<style lang='less' scoped>
.setPassword {
  padding: 0.9rem 0.3rem 0;
  .password {
    display: flex;
    align-items: center;
    padding: 0.4rem 0 0.2rem;
    p {
      font-size: 0.28rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      padding: 0;
    }
    .pass-tips {
      display: flex;
      align-items: center;
      .tips {
        width: 0.22rem;
        height: 0.22rem;
        margin: 0 0.1rem;
      }
      span {
        font-size: 0.22rem;

        font-weight: 400;
        color: rgba(255, 67, 67, 1);
      }
    }
  }
  .input {
    .phone {
      font-size: 0.28rem;
      display: flex;
      border-bottom: 1px solid #dedede;
      padding: 0.2rem 0;
      align-items: center;
      justify-content: space-between;
      .show {
        width: 0.4rem;
        height: 0.4rem;
      }
      .password-input {
        width: 90%;
      }
      .arrowhead {
        display: flex;
        align-items: center;
        flex: 1;
        .arrowheads {
          width: 0.5rem;
          height: 0.5rem;
          transition: transform 1s;
        }
      }
      .tel {
        flex: 4;
      }
    }
  }
  .login-btn {
    width: 90%;
    margin: 0.9rem auto 0;
    .van-button {
      width: 100%;
      background: rgba(255, 67, 67, 1);
      border-radius: 0.08rem;
    }
  }
  .log-nav {
    margin: 0.4rem 5% 1rem;
    font-size: 0.24rem;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    span:nth-child(2) {
      color: #ff4343;
      padding-left: 0.1rem;
    }
    span:nth-child(2)::after {
      content: "";
      display: block;
      width: 0.8rem;
      height: 1px;
      background: rgba(255, 67, 67, 1);
      margin-left: 1.1rem;
    }
  }
  .van-popup {
    width: 85%;
    .finish-tips {
      text-align: center;
      p {
        padding: 0.8rem 0;
        font-size: 0.32rem;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }

      button {
        width: 100%;
        background: #fff;
        padding: 0.37rem 0;
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(26, 26, 26, 1);
        border-top: 0.01rem solid #dedede !important;
      }
    }
  }
}
</style>